import { render, staticRenderFns } from "./FormularioDenuncia.vue?vue&type=template&id=5470e716&scoped=true&"
import script from "./FormularioDenuncia.vue?vue&type=script&lang=ts&"
export * from "./FormularioDenuncia.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioDenuncia.vue?vue&type=style&index=0&id=5470e716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470e716",
  null
  
)

export default component.exports